import {Link} from 'react-router-dom';
import AurTagSelectList from '../../../eca-doc-list/bulk-tagging/AurTagSelectList';
import {useCallback, useState} from 'react';
import {ITag} from '../../field-management/custom-field/DraggableTag';
import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

const TagSelectList: React.FC = () => {
  const [selectedTags, setSelectedtags] = useState<ITag[]>([]);
  const updateSelectedTags = useCallback((tags: ITag[]) => {
    setSelectedtags(tags);
  }, []);
  const renderSubHeader = () => {
    return (
      <Typography className={`typo-text body4_size selected-count-text`}>
        {t('ecaDocList.bulkTagging.tagsSelectedCount', {
          selectedCount: selectedTags.length,
        })}
      </Typography>
    );
  };
  const allTags = [
    {
      tagValueId: 35,
      tagValue: 'Test_tag3',
      displayOrder: 3,
      isDeleted: false,
    },
    {
      tagValueId: 34,
      tagValue: 'Test_tag2',
      displayOrder: 2,
      isDeleted: false,
    },
    {
      tagValueId: 33,
      tagValue: 'Test_Tag1',
      displayOrder: 1,
      isDeleted: false,
    },
  ];

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>TagSelectList</h1>
        <div>
          TagSelectList display list of tags with search on bulk tagging and
          document viewer.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <Box style={{width: '500px'}}>
          <AurTagSelectList
            onSelectionChange={updateSelectedTags}
            selectedTags={selectedTags}
            renderSubHeader={renderSubHeader}
            items={allTags}
            selectAllLabel={t('common.selectAll')}
            tagAction="tag"
            isError={false}
            height={360}
          />
        </Box>
      </div>
    </>
  );
};

export default TagSelectList;
